import script from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToPlay.vue?vue&type=script&setup=true&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=14be2b34&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14be2b34"]])

export default __exports__